// 简单的i18n插件
export default {
  install(Vue) {
    Vue.prototype.$t = function(key) {
      const translations = this.$store.getters.currentTranslations
      return translations[key] || key
    }
  }
}
